import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=2566eb5c"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=2566eb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports